import Panzoom from '@panzoom/panzoom'

export default () => ({

	init() {
		const elem = document.getElementById('zoom-image')
		const btnZoomIn = document.getElementById('btn-zoom-in')
		const btnZoomOut = document.getElementById('btn-zoom-out')

		this.panzoom = Panzoom(elem, {
			minScale: .7,
			maxScale: 2,
			startTransform: 'scale(.7)',
		});	
		
		elem.parentElement.addEventListener('wheel', this.panzoom.zoomWithWheel)

		btnZoomIn.addEventListener('click', () => {
			this.panzoom.zoomIn()
		})
		
		btnZoomOut.addEventListener('click', () => {
			this.panzoom.zoomOut()
		})	

		setTimeout(() => {
			this.panzoom.zoom(0.7);
			// this.panzoom.pan( 0, -150 );
		});

	}
});